import React from 'react';
import Usuario from './Usuario';
import { Configurations } from './Configurations';
const AuthContext = React.createContext();

class AuthProvider extends React.Component {

  constructor() {
    super();
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.configs = new Configurations();
    Usuario.setLoggedUser = Usuario.getDadosUsuario(window.localStorage.getItem(this.configs.tokenKey));
    this.state = { 
      isAuth: !!Usuario.getLoggedUser
      // isAuth: !!window.localStorage.getItem(this.configs.tokenKey)
    }
  }

  login(token) {
    window.localStorage.setItem(this.configs.tokenKey, token);
    const _loggedUser = Usuario.getDadosUsuario(token);
    Usuario.setLoggedUser = _loggedUser;

    this.setState({ isAuth: true });
  }

  logout() {
    Usuario.setLoggedUser = null;
    window.localStorage.removeItem(this.configs.tokenKey);
    this.setState({ isAuth: false });
  }

  render() {
    return (
      <AuthContext.Provider
        value={{
          isAuth: this.state.isAuth,
          login: this.login,
          logout: this.logout
        }}
      >
        {this.props.children}
      </AuthContext.Provider>
    )
  }

}
const AuthConsumer = AuthContext.Consumer;

const WithAuthContext = (Component) => {
  return (props) => (
    <AuthContext.Consumer>
      {({ isAuth, logout }) => {
        return <Component {...props} isAuth={isAuth} logout={logout} />
      }}
    </AuthContext.Consumer>
  )
}



export { AuthProvider, AuthConsumer, WithAuthContext }